import { RootStore } from './root.store';
import { makeAutoObservable } from 'mobx';
import { IDelegate } from '../domains/delegation-information.domain';
import { isEmailValid } from '../utils/validators';

export class DelegationInformationStore {
  root: RootStore;
  private _delegates: IDelegate[] = [];

  constructor(root: RootStore) {
    makeAutoObservable(this);
    this.root = root;
  }

  init() {
    this._delegates =
      this.root.quoteStore.quoteInfo?.customer.customerDelegates.map(x => ({
        uiKey: crypto.randomUUID(),
        id: x.id,
        status: x.status,
        fullName: {
          value: x.name,
        },
        email: {
          value: x.email,
          errorType: isEmailValid(x.email) ? undefined : 'invalid',
        },
      })) ?? [];
  }

  get delegates(): IDelegate[] {
    return this._delegates;
  }

  addDelegate() {
    this._delegates.push({
      uiKey: crypto.randomUUID(),
      id: 0,
      status: '',
      fullName: {
        value: '',
      },
      email: {
        value: '',
        errorType: 'required',
      },
    });
  }

  removeDelegate(index: number) {
    this._delegates.splice(index, 1);
  }

  updateDelegate(index: number, field: keyof IDelegate, value: string) {
    if (field === 'id' || field === 'status' || field === 'uiKey') return;
    this._delegates[index][field] = {
      value: value,
      errorType: !value ? 'required' : undefined,
    };
    if (value) {
      if (field === 'email') {
        this._delegates[index].email.errorType = isEmailValid(value) ? undefined : 'invalid';
      }
    }
  }

  get isFormValid(): boolean {
    return this._delegates.every(delegate => !delegate.email.errorType);
  }
}
